import { isIOS, isAndroid } from 'react-device-detect';

import { Platform } from '@/constants/platform';
import { getQueryParam } from './queryParams';

export const getPlatform = () => {
  const queryParamsPlatform = getQueryParam('platform');
  return queryParamsPlatform || getDevicePlatform();
};

const getDevicePlatform = () => {
  if (isIOS) {
    return Platform.IOS;
  }
  if (isAndroid) {
    return Platform.ANDROID;
  }
  return Platform.WEB;
};
